var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQtBarcode = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M126.044 153.843v83.738H42.305v-83.738zm69.782 0v13.956h27.912v-13.956h13.957v55.826h-41.87v-13.957H181.87v41.87h-27.913v-83.739zm41.869 69.782v13.956h-13.957v-13.956zm-27.913 0v13.956h-13.956v-13.956zM126.044 42.192v83.738H42.305V42.192zm111.65 0v83.738h-83.738V42.192z"
})));
export default SvgQtBarcode;